import { articleFieldGroups } from "./articleDetailsPresentation";
import { createSelector } from "@reduxjs/toolkit";
import { openapi } from "../../openapi";
import type { IRootState } from "../app/store";
import { selectProjectNo } from "../globalSelectors";

export const selectArticleNumber = (state: IRootState) => state.drofusOccurrenceValidation.articleDetailsNumber;
export const selectArticleSearch = (state: IRootState) => state.drofusOccurrenceValidation.articleDetailsSearch;
export const selectArticleDetailsArg = createSelector([selectProjectNo, selectArticleNumber], (projectNo, articleNumber) =>
  projectNo && articleNumber ? { body: { projectNo, articleNumber } } : null
);
const selectArticleQuerySelector = createSelector([selectArticleDetailsArg], arg =>
  arg ? openapi.endpoints.postFunctionsDrofusArticlesDetails.select(arg) : null
);
const selectArticleQuery = createSelector([selectArticleQuerySelector, (state: IRootState) => state],
  (query, state) => query?.(state)
);
export const selectArticleDetailsView = createSelector(
  [selectArticleNumber, selectArticleSearch, selectArticleQuery], (number, search, query) => {
    const data = query?.data;
    return {
      opened: number != null,
      title: data?.article?.name ? `${number} – ${String(data.article.name)}` : `Artikkel ${number ?? ""}`,
      search,
      loading: !query || query.isUninitialized || query.isLoading,
      error: query?.isError ?? false,
      notFound: data?.article === null,
      groups: articleFieldGroups(data, search),
      fetchedAt: data?.fetchedAt,
      fieldCount: data ? new Set([...data.fields.map(field => field.id), ...Object.keys(data.article ?? {})]).size : 0,
    };
  }
);
